export const environment = {
  env: 'prod',
  API_URL: 'https://api.silberfluss.io',
  joditKey: 'B844J-1B6J1-AEL55-NNI9X',
  WEBSOCKET_URL: 'wss://api.silberfluss.io/ws',
  KEYCLOAK_URL: 'https://app.silberfluss.io/auth/',
  MAX_UPLOAD_SIZE_MB: 500,
  ALLOWED_FILE_FORMATS: 'application/pdf, image/png, image/jpeg',
};
